import React ,{useRef ,useEffect, useState}from 'react';
import './new-PI.scss'
import DynamicInputList from '../software-dynamic-version-3/list-input-v-3';
import NewPIAdd from './new-PI-add';
import NewPIService from '../../services/PI.service';
import moment from 'moment'
import securityService from '../security/security.service';
import DialogInput from '../software-dynamic-version-3/popup-dialog-input-v-3'


let setPIID = '';
let ShowPopup  = false;
const NewPIList = (props) => {

  const [loadData,setLoadData] = useState(true)
  const [PaymentVerificationStatus,setPaymentVerificationStatus] = useState(props.path == `CRM`? null  : 2)

  const [printedByUserName,setPrintedByUserName] = useState('')

  useEffect(()=>{
      
    securityService.getPrintedByUserName((value)=>{ 
      console.log(value);
      setPrintedByUserName(value);
    })

    setTimeout(() => {
      setLoadData(false)
    }, 200);
  },[])
let commands = [
  {Id:'Email',Content:'E', BgColor:'#062E51' ,Color:'#e1ac53',
    Input:{
    Route:'Email' ,
    Title:null, 
    Security:`PI${props.path}List`,
    Width:'1000px'
  }},
  {Id:'Message',Content:'M', BgColor:'#062E51' ,Color:'#e1ac53',
    Input:{
    Route:'Message' ,
    Title:'', 
    Security:`PI${props.path}List`,
    Width:'800px'
  }},
  {Id:'UploadPDF',Content:'A', BgColor:'#062E51' ,Color:'#e1ac53',
    Input:{
    Route:'UploadPDF' ,
    Title:'Upload PDF Files.', 
    Security:`PI${props.path}List`,
    Width:'800px'
  }}
]
  let columns = props.path == 'CRM' ? [
    {  field: "Commands",headerText:'Commands',width:'180',textAlign:'center' ,headerTextAlign:'center',other:[{ button: commands}]},
    {  field: "SupplierName",headerText:'Supplier',width:'140',textAlign:'center' ,headerTextAlign:'center',other:[]},
    {  field: "SalesAgentName",headerText:'Sales Agent',width:'130',textAlign:'center' ,headerTextAlign:'center',other:[]},
    {  field: "PaymentType",headerText:'Payment Type',width:'140',textAlign:'center' ,headerTextAlign:'center',other:[]},
    {  field: "PaymentReferenceNo",headerText:'Bank Account',width:'170',textAlign:'center' ,headerTextAlign:'center',other:[]},
    {  field: "PaymentSenderName",headerText:'Sender Name',width:'150',textAlign:'center' ,headerTextAlign:'center',other:[]},
    {  field: "CurrencyName",headerText:'Currency',width:'150',textAlign:'center' ,headerTextAlign:'center',other:[]},
    {  field: "PaymentDescription",headerText:'TT Amount',width:'160',textAlign:'center' ,headerTextAlign:'center',other:[]},
    {  field: "PIReferenceNo",headerText:'PI Reference No',width:'150',textAlign:'center' ,headerTextAlign:'center',other:[]},
    {  field: "PINo",headerText:'PI No',width:'130',textAlign:'center' ,headerTextAlign:'center',other:[]},
    {  field: "ReceiptAmount",headerText:'ALLOCATION AMOUNT',width:'130',textAlign:'Right' ,headerTextAlign:'center',other:[{'format':'n0'}]},
    {  field: "SalesAgentStatus",headerText:'Sales Agent Status',width:'190',textAlign:'center' ,headerTextAlign:'center',other:[]},
    {  field: "CRMStatusDate",headerText:'CRM Status Date',width:'145',textAlign:'Right' ,headerTextAlign:'center',other:[{}]},
    {  field: "CRMName",headerText:'CRM Name',width:'145',textAlign:'center' ,headerTextAlign:'center',other:[]},
    {  field: "AdjustmentAmount",headerText:'Adjustment Amount',width:'165',textAlign:'Right' ,headerTextAlign:'center',other:[{'format':'n0'}]},
    {  field: "Remarks",headerText:'Remarks',width:'140',textAlign:'center' ,headerTextAlign:'center',other:[]},
    {  field: "BookAmount",headerText:'Booking Amount',width:'135',textAlign:'Right' ,headerTextAlign:'center',other:[{'format':'n0'}]},
    {  field: "CRMStatus",headerText:'CRM Status',width:'140',textAlign:'Left' ,headerTextAlign:'center',other:[]},
    {  field: "ConsigneeName",headerText:'Consignee',width:'155',textAlign:'Left' ,headerTextAlign:'center',other:[]},
    {  field: "TradeBoardLetterStatus",headerText:'Trade Board Letter',width:'145',textAlign:'center' ,headerTextAlign:'center',other:[{visible:false}]},
    {  field: "SerialNo",headerText:'Serial No',width:'80',textAlign:'Right' ,headerTextAlign:'center',other:[]},
    {  field: "CustomerName",headerText:'Customer',width:'150',textAlign:'center' ,headerTextAlign:'center',other:[]},
    {  field: "CustomerEmail",headerText:'Customer Email',width:'180',textAlign:'center' ,headerTextAlign:'center',other:[]},
    {  field: "ConfirmConsigneeName",headerText:'Confirm Consignee',width:'155',textAlign:'Left' ,headerTextAlign:'center',other:[{
        'template': (props) => {
          return (
            <div>{props.ConfirmConsigneeName ? 'Yes' : 'No'}</div>
          );
        }
       }]},
    {  field: "CountryName",headerText:'Country',width:'140',textAlign:'center' ,headerTextAlign:'center',other:[]},
    {  field: "CityName",headerText:'City',width:'120',textAlign:'center' ,headerTextAlign:'center',other:[]},
    {  field: "PortName",headerText:'Port',width:'120',textAlign:'center' ,headerTextAlign:'center',other:[]},
    {  field: "ShipmentType",headerText:'Shipment Type',width:'140',textAlign:'center' ,headerTextAlign:'center',other:[]},
    {  field: "PurchaseSource",headerText:'Purchase Source',width:'160',textAlign:'center' ,headerTextAlign:'center',other:[]},
    {  field: "CreationDate",headerText:'Creation Date',width:'140',textAlign:'Right' ,headerTextAlign:'center',other:[{}]},
    {  field: "UserName",headerText:'User Name',width:'140',textAlign:'center' ,headerTextAlign:'center',other:[]},
    {  field: "VesselName",headerText:'Vessel Name',width:'140',textAlign:'center' ,headerTextAlign:'center',other:[]},
    {  field: "VoyageNo",headerText:'Voyage No',width:'130',textAlign:'Left' ,headerTextAlign:'center',other:[]},
    {  field: "ETD",headerText:'ETD',width:'120',textAlign:'Right' ,headerTextAlign:'center',other:[{}]},
    {  field: "ETA",headerText:'ETA',width:'120',textAlign:'Right' ,headerTextAlign:'center',other:[{}]},
    {  field: "ShortAmount",headerText:'Short Amount',width:'130',textAlign:'Right' ,headerTextAlign:'center',other:[]},
    {  field: "SalesAgentStatusDate",headerText:'Sales Agent Status Date',width:'170',textAlign:'Right' ,headerTextAlign:'center',other:[{}]},

    {  field: "PaymentVerificationStatus",headerText:'Payment Verification Status',width:'175',textAlign:'center' ,headerTextAlign:'center',other:[{
        'template': (props) => {
          return (
            <div className={props.PaymentVerificationStatus === "PENDING VERIFICATION" ? `pendingPayment` : ''}>
              {props.PaymentVerificationStatus}
            </div>
          );
        }
       }]},

     {  field: "PaymentVerificationStatusDate",headerText:'Payment Verification Status Date',width:'175',textAlign:'Right' ,headerTextAlign:'center',other:[{}]},
     {  field: "ProformaInvoicePaymentDetailID",headerText:'ID',width:'175',textAlign:'Center' ,headerTextAlign:'center',other:[]},
      ]
      :
      [
        {  field: "Commands",headerText:'Commands',width:'180',textAlign:'center' ,headerTextAlign:'center',other:[{ button: commands}]},
        {  field: "PIID",headerText:'ID',width:'100',textAlign:'Left' ,headerTextAlign:'center',other:[{'visible':false }]},
        {  field: "SerialNo",headerText:'Serial No',width:'70',textAlign:'Right' ,headerTextAlign:'center',other:[]},
        {  field: "PINo",headerText:'PI No',width:'110',textAlign:'center' ,headerTextAlign:'center',other:[]},
        {  field: "PIReferenceNo",headerText:'PI Reference No',width:'120',textAlign:'center' ,headerTextAlign:'center',other:[]},
        {  field: "SupplierName",headerText:'Supplier',width:'140',textAlign:'center' ,headerTextAlign:'center',other:[]},
        {  field: "CustomerName",headerText:'Customer',width:'150',textAlign:'center' ,headerTextAlign:'center',other:[]},
        {  field: "CustomerEmail",headerText:'Customer Email',width:'150',textAlign:'center' ,headerTextAlign:'center',other:[]},
        {  field: "SalesAgentName",headerText:'Sales Agent',width:'130',textAlign:'center' ,headerTextAlign:'center',other:[]},
        {  field: "ConsigneeName",headerText:'Consignee',width:'155',textAlign:'center' ,headerTextAlign:'center',other:[]},
        {  field: "ConfirmConsigneeName",headerText:'Confirm Consignee',width:'155',textAlign:'center' ,headerTextAlign:'center',other:[{
            'template': (props) => {
              return (
                <div>{props.ConfirmConsigneeName ? 'Yes' : 'No'}</div>
              );
            }
           }]},
        {  field: "CommissionAmountPerUnit",headerText:'Commission Amt Per Unit',width:'155',textAlign:'Left' ,headerTextAlign:'center',other:[{'visible':false , 'format':'n0'}]},
        {  field: "ApproveCommissionAmountPerUnit",headerText:'Approve Commission Amt Per Unit',width:'155',textAlign:'Left' ,headerTextAlign:'center',other:[{'visible':false }]},
        {  field: "AbsoluteCommissionAmount",headerText:"Commission Absolute Comm Amt",width:'155',textAlign:'Left' ,headerTextAlign:'center',other:[{'visible':false , 'format':'n0'}]},
        {  field: "ApproveAbsoluteCommissionAmount",headerText:"Approve Commission Absolute Comm Amt",width:'155',textAlign:'Left' ,headerTextAlign:'center',other:[{'visible':false }]},
        {  field: "CountryName",headerText:'Country',width:'140',textAlign:'center' ,headerTextAlign:'center',other:[]},
        {  field: "CityName",headerText:'City',width:'120',textAlign:'center' ,headerTextAlign:'center',other:[]},
        {  field: "PortName",headerText:'Port',width:'120',textAlign:'center' ,headerTextAlign:'center',other:[]},
        {  field: "ShipmentType",headerText:'Shipment Type',width:'140',textAlign:'center' ,headerTextAlign:'center',other:[]},
        {  field: "BookAmount",headerText:'Booking Amount',width:'135',textAlign:'Right' ,headerTextAlign:'center',other:[{ 'format':'n0'}]},
        {  field: "CurrencyName",headerText:'Currency',width:'150',textAlign:'center' ,headerTextAlign:'center',other:[]},
        {  field: "PrimaryCommissionPercentOnAdjustment",headerText:"Primary Comm % On Adjustment",width:'155',textAlign:'Left' ,headerTextAlign:'center',other:[{'visible':false }]},
        {  field: "SecondaryCommissionPercentOnAdjustment",headerText:"Secondary Comm % On Adjustment",width:'155',textAlign:'Left' ,headerTextAlign:'center',other:[{'visible':false }]},
        {  field: "ApproveSecondaryCommissionPercentOnAdjustment",headerText:"Approve Secondary Comm % On Adjustment",width:'155',textAlign:'Left' ,headerTextAlign:'center',other:[{'visible':false }]},
        {  field: "AdjustmentAmount",headerText:'Adjustment Amount',width:'165',textAlign:'Right' ,headerTextAlign:'center',other:[{'format':'n0'}]},
        ...(props.path === 'Supervisor' ?[{  field: "BasePriceAgent",headerText:'Base Price Agent',width:'165',textAlign:'Right' ,headerTextAlign:'center',other:[{'format':'n0'}]}] : []),
        ...(props.path === 'Supervisor' ?[{  field: "BasePriceCompany",headerText:'Base Price Company',width:'165',textAlign:'Right' ,headerTextAlign:'center',other:[{'format':'n0'}]}] : []),
        {  field: "PurchaseSource",headerText:'Purchase Source',width:'150',textAlign:'center' ,headerTextAlign:'center',other:[]},
        {  field: "TradeBoardLetterStatus",headerText:'Trade Board Letter',width:'145',textAlign:'center' ,headerTextAlign:'center',other:[{visible:false}]},
        {  field: "Remarks",headerText:'Remarks',width:'140',textAlign:'center' ,headerTextAlign:'center',other:[]},
        {  field: "CreationDate",headerText:'Creation Date',width:'140',textAlign:'Right' ,headerTextAlign:'center',other:[]},
        {  field: "UserName",headerText:'User Name',width:'140',textAlign:'center' ,headerTextAlign:'center',other:[]},
        {  field: "VesselName",headerText:'Vessel Name',width:'140',textAlign:'center' ,headerTextAlign:'center',other:[]},
        {  field: "VoyageNo",headerText:'Voyage No',width:'130',textAlign:'center' ,headerTextAlign:'center',other:[]},
        {  field: "ETD",headerText:'ETD',width:'120',textAlign:'Right' ,headerTextAlign:'center',other:[{}]},
        {  field: "ETA",headerText:'ETA',width:'120',textAlign:'Right' ,headerTextAlign:'center',other:[{}]},
        {  field: "ReceiptAmount",headerText:'ALLOCATION AMOUNT',width:'130',textAlign:'Right' ,headerTextAlign:'center',other:[{'format':'n0'}]},
        {  field: "ShortAmount",headerText:'Short Amount',width:'130',textAlign:'Right' ,headerTextAlign:'center',other:[{'format':'n0'}]},
        {  field: "UnApprovedCRMAmount",headerText:'UnApproved CRM Amount',width:'130',textAlign:'Right' ,headerTextAlign:'center',other:[{'format':'n0'}]},
        {  field: "SalesAgentStatus",headerText:'Sales Agent Status',width:'145',textAlign:'center' ,headerTextAlign:'center',other:[]},
        {  field: "SalesAgentStatusDate",headerText:'Sales Agent Status Date',width:'140',textAlign:'Right' ,headerTextAlign:'center',other:[{}]},
        {  field: "PaymentVerificationStatus",headerText:'Payment Verification Status',width:'175',textAlign:'center' ,headerTextAlign:'center',other:[{
          'template': (props) => {
           return (
             <div className={props.PaymentVerificationStatus === "PENDING VERIFICATION" ? `pendingPayment` : ''}>
               {props.PaymentVerificationStatus}
             </div>
           );
         }
        }]},
        {  field: "PaymentVerificationStatuss",headerText:'Payment Verification Status',width:'175',textAlign:'center' ,headerTextAlign:'center',other:[{'visible':false,
          'template': (props) => {
            return (
              <div className={props.PaymentVerificationStatus === "PENDING VERIFICATION" ? `pendingPayment` : ''}>
                {props.PaymentVerificationStatus}
              </div>
            );
          }
         }]},
        {  field: "PaymentVerificationStatusDate",headerText:'Payment Verification Status Date',width:'175',textAlign:'Right' ,headerTextAlign:'center',other:[{}]},
        {  field: "CRMName",headerText:'CRM Name',width:'145',textAlign:'center' ,headerTextAlign:'center',other:[]},
        {  field: "CRMStatus",headerText:'CRM Status',width:'140',textAlign:'center' ,headerTextAlign:'center',other:[]},
        {  field: "CRMStatusDate",headerText:'CRM Status Date',width:'145',textAlign:'Right' ,headerTextAlign:'center',other:[{}]},
      ];
  


       const getpiid = (e)=>{
            setPIID = e
        }

        const isShowPopup =  (e)=>{
          ShowPopup = e
        }
  const updateProformaInvoice = async (id,value,getListService) => {
  try {
    console.log(id,value)
    let response = await  NewPIService.updatingSp(id,value);
    console.log(response)
    if(response){

          setTimeout(() =>          {
          setPIID = ''
          ShowPopup  = false
          getListService()
        }, 200);
        
    }
  } catch (error) {
              getListService()

  }    

  };




const dialogRef = useRef(null);
const showDialog = (header,title,actions =['OK']) => {
            return new Promise((resolve) => {
            // Destroy existing dialog if any
            if (dialogRef.current) {
              dialogRef.current.destroy();
            }
            const okButtons = actions.map((action) => ({
              buttonModel: {
                content: action,
                cssClass: 'e-flat',
                isPrimary: action === 'OK',
              },
              click: (e) => {
                
                hideDialog()
                // setTimeout(()=>document.getElementById(`${inputid}_display`).select(),100)
                        // SaveButton(props.GridID , 'visible')
                resolve(action);
              },
            }));
            // Create a new dialog instance
            dialogRef.current = new DialogInput({
              content: ()=>(<>{title}</>),
              header:header,
              width:'400px',
              showButtons: true,
              buttons:okButtons
            });
            // Show the dialog programmatically
            dialogRef.current.show();
          
          });
          
          };
          const hideDialog = () =>{
          if (dialogRef.current) {
          }
          dialogRef.current.hide();
          dialogRef.current.destroy();
          dialogRef.current = null; // Clean up reference after destruction
          }

        
 
       const listActionComplete = async (grid , args ,getListService ,selectedRow ,
        setDataSourceState , addUserLog , editUserLog,dataSourceLength , dataSourceState
       )=>{
        console.log(args )
        console.log(getListService )
        console.log(selectedRow )
        if (args.requestType === 'beginEdit' || args.requestType === 'add') {
          }
        if (args.requestType == 'save' || args.requestType == 'cancel' ) {
          // setTimeout(()=>{getListService()},560)
        }


        if(args.requestType == 'save' ){
            
          
          console.log(ShowPopup);
          console.log(setPIID);

          if(props.path != "CRM"){

            if(ShowPopup == true ){

      
        let response = await  showDialog('Confirmation' ,<span class="error-success">DO WANT TO TO RELEAES OF SURRENDER BL?</span>,['Release','Surrender BL'])
          console.log(response);
            
        if(response && setPIID != ''){
       await  updateProformaInvoice(setPIID,response,getListService)
       
        }
      
  }else{

    if(setPIID != ''){

    let result = await  updateProformaInvoice(setPIID, 'undefined',getListService)
    

    }
    
  }       }else if(props.path == "CRM"){

      console.log(dataSourceState)

  let getSalesAgentByID =  dataSourceState.filter((res)=>{ 
    console.log(res.PIID)
    console.log(setPIID)
    
    // return res.PIID == setPIID  ? res.SalesAgentStatus : ''
    if(res.PIID == setPIID){ 
    if(res.SalesAgentStatus == 'Release' ||  res.SalesAgentStatus == 'Surrender BL')
    return res.SalesAgentStatus
    }
  })
  // .some((val)=>{
  //   return val.SalesAgentStatus 
  // })
  console.log(getSalesAgentByID)
  console.log(getSalesAgentByID.length > 0 ?  getSalesAgentByID[0].SalesAgentStatus : 'undefined')
  await updateProformaInvoice(setPIID, getSalesAgentByID.length > 0 ?  getSalesAgentByID[0].SalesAgentStatus : 'undefined' , getListService)
 

    }

        }


       if (args.requestType === 'save'  && args.action   === 'edit') {
               let userId =  securityService.getLoggedInUserId()
               const data = {
                 UserID: userId,
                 ...args.data,
                 PIDate : moment(args.data.PIDate).format('YYYY-MM-DD'),
                 ETD: args.data.ETD != undefined ? moment(args.data.ETD).format('YYYY-MM-DD') : null,	
                 ETA: args.data.ETA != undefined ?  moment(args.data.ETA).format('YYYY-MM-DD') : null,	
                 ProductCategoryID:1,
                   ApproveAbsoluteCommissionAmount:args.data.ApproveAbsoluteCommissionAmount == false? '0': '1', 
                 // ConfirmConsigneeName:args.data.ConfirmConsigneeName == false? 0: 1, 
                 ConfirmConsigneeName:args.data.ConfirmConsigneeNames == "true" ? true : false, 
                 ApproveCommissionAmountPerUnit:args.data.ApproveCommissionAmountPerUnit == false? '0': '1', 
                 ApprovePrimaryCommissionPercentOnAdjustment: '0', 
                 ApproveSecondaryCommissionPercentOnAdjustment: '0', 
               };
               console.log('args: ', data)
               NewPIService.PIEdit(data)
                 .then((response) => {
                   // let EditData = {
                   //   FinishDrop: args.data.FinishDrop,
                   //   FinishLength: args.data.FinishLength,
                   //   FinishSize: args.data.FinishSize,
                   //   FinishWidth: args.data.FinishWidth,
                   //   ProductDesc: args.data.ProductDesc,
                   //   UnitOfMeasurement: args.data.UnitOfMeasurement
                     
                   //           }
                   //           let totalColumns = Object.keys(EditData);
                   //           console.log(totalColumns)
                   //           AuditTableInput.auditEdit(totalColumns,selectedRows,EditData,`ProductFinishSize`,args.data.ProductFinishSizeID)
                   // getListService();
                   console.log(response)});
             }
        }
       //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************

        // Defines the  boolean
        // @default true
    let  allowTemplate = true
    let  allowGrouping = true
    let  allowExcelExport =true
    let  allowPdfExport = true
    let  showColumnChooser = true
    let  allowPaging = false
    let  allowDataBound = false
    let  allowGridSum = true
    let  isDialog = props.IsDialog == true ? true : false

       
        // Defines the  string
      // @default FabricGodownTransactions${typeMode} 
        let ListSecurity=  `PI${props.path}List`
        let AddSecurity=  `PI${props.path}Add`
        let EditSecurity=  `PI${props.path}Edit`
        let DeleteSecurity=  `PI${props.path}Delete`
        // let ListSecurity=  'NewPIList'
        // let AddSecurity=  'NewPIAdd'
        // let EditSecurity=  'ExportSaleInvoiceEdit'
        // let DeleteSecurity=  'ExportSaleInvoiceDelete'
       // Defines the  ['Add','Edit','Delete','Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'] | 'All'
       //  @default 'All'
      let toolbarOptions = 'All'
      

      const toolbarClicking =  async (args)=>{
        console.log(args)
       }
       // Defines the 'Descending' | 'Ascending'
       //  @default 'Descending'
      let DefaultSortedColumnSort ='Descending';

       /* Defines the [{
                    TableName:'FabricGodownTransactions' ,
                    TableID:'FabricGodownTransactionsID',
                   // Optional if Delete is Soft // TableSecurity:'FabricGodownTransactionsDelete',
                }]*/
    //  @default [] 
    
      let listDelete =  [{ TableName:['ProformaInvoice_PaymentDetail','Proformainvoice'] ,TableID:['PIID'],  }]
    // let listDelete = [];
       
    // Defines 'Hard' | 'Soft' 
    // @Default 'Hard'
    let deleteType = 'Hard'


/* Defines the [   {field:'IsDeleted',
OPTIONAL HAI operator:'equal' or more check syncfusion documentation
        value:'No'},...more
        ] | []
      @default [] */
    //   let filterColumns = [{ field: 'IsDeleted', value: 'No' }];
      let filterColumns = [];

      /* Defines the [ColumnNames] | []
      @default [] */
    //   let groupColumns = ['IsDeleted','AccountTitleHawalaDr'];
      let groupColumns = [];

/* Defines the 'Dialog' | 'Normal'
      @default 'Dialog' */
      let gridEditSettingMode = 'Dialog';

/* Defines the '<p></p>' | Can give HTML | AND REACT FUNCTION LIKE HeaderTemplate
      @default '<p></p>' */
      // let gridEditSettingHeaderTemplate = '<p></p>';
      let gridEditSettingHeaderTemplate =  (e)=>{
    console.log(e)
    return e.isAdd ? (
      <p>Add New PI </p>
      
    ) :
      (
        <p>Details Of PI </p>
        // <PIEdit dataList={dataSourceState} {...props}> </PIEdit>

      );
        // return `${e.isAdd == true ? '<p>Details Of PI NO</p>':''}`;

  };

      /* Defines the  [ColumnNames] | []
      @default [] */
           //   let gridSumColumns = ['HawalaCommissionPercent'];
      let gridSumColumns = [
        'TotalOrderAmount',
        // 'TotalGrossWeightInKg',
        // 'TotalNetWeightInKg',
      ];


    const getExportSaleInvoiceForList = async ()=>{
      let data = { 
        PIID:0,
        FromPIDate:'01-JAN-01',
        ToPIDate:moment().format('DD-MMM-YY'),
        SupplierID:0,
        CustomerID:0,
        CountryID:0,
        CityID:0,
        PortID:0,
        CountryCityPortID:0,
        SalesAgentID:0,
        ShipmentTypeID:0,
        CurrencyID:0,
        PurchaseSourceID:0,
        TradeBoardLetterStatusID:0,
        SalesAgentStatusID:0,
        PaymentVerificationStatus:PaymentVerificationStatus || null,
        CRMStatusID:0,
        CRMID:0,
        ProformaInvoicePaymentDetailID:0,
        PaymentTypeID:0,
        UserID:securityService.getLoggedInUserId()
      }
      return NewPIService.PIForlist(data);
    }


    return (
        <DynamicInputList
        Id='ProformaInvoice'
        ListTitle={`PI ${props.path == 'SalesAgent' ? 'Sales Agent' : props.path}- LIST`}
        ColumnsList={columns}
        GridDataSource= {[
                    {
                        // DataSourceType: loadData == true   ? 'Function' :'Rest',
                        DataSourceType: 'Function',
                        DataSource:  ()=> getExportSaleInvoiceForList()
                        }]}
        DefaultSortedColumnName={'PIID'}
        GridDialog={[
            {
                DialogType:'Self',
                Dialog:<NewPIAdd
                  userName={printedByUserName}
                  isPreview={false}
                   PIIDGet={getpiid}
                    type={props.path} 
                    popup={isShowPopup}
                     > </NewPIAdd>
                // Dialog:<NewPIAdd ShopID={1} /> 
                }
        ]}
        ListActionComplete={listActionComplete}
        ToolbarClicking ={toolbarClicking}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
            AllowTemplate={allowTemplate}
            ToolbarOption={toolbarOptions}
            // AllowGrouping={allowGrouping}
            // AllowExcelExport={allowExcelExport}
            // AllowPdfExport={allowPdfExport} 
            // ShowColumnChooser={showColumnChooser}
            // AllowPaging={allowPaging}
            AllowDataBound={allowDataBound}
            ListSecurity={ListSecurity}
            AddSecurity={AddSecurity}
            EditSecurity={EditSecurity}
            DeleteSecurity={DeleteSecurity}
            // DefaultSortedColumnSort={DefaultSortedColumnSort}
            FilterColumns={filterColumns} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
            // GroupColumns={groupColumns} 
            ListDelete={listDelete}
            DeleteType={deleteType} 
            // GridEditSettingMode={gridEditSettingMode}
            GridEditSettingHeaderTemplate={gridEditSettingHeaderTemplate}
            GridSumColumns={gridSumColumns}
            AllowGridSum={allowGridSum}
            HeadTitle={'PI'}
            IsDialog={isDialog}
            {...props}
            ></DynamicInputList>
            
            );
}
export default NewPIList;